import { useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Transition } from 'react-transition-group'

import UIIcon, { UIIconType } from '@/components/UI/UIIcon'
import { useRunnerState } from '@/composables/useRunnerState'
import { useRunnerUITransition } from '@/composables/useRunnerUITransition'

const icons = ['pedroBubble', 'pedroBubble', 'pedroBubble', 'pedroBrocoli', 'pedroNarnia']

export default function RunnerUIPedroTimeline() {
  const { t } = useTranslation()

  const { gameState, persona, scenario } = useRunnerState()

  const isPedro1 = persona === 'pedro' && scenario === 1
  const segment = gameState.currentSegment

  const [isVisible, setIsVisible] = useState(false)
  const [jauge, setJauge] = useState(0)
  const [index, setIndex] = useState(0)

  useLayoutEffect(() => {
    if (isPedro1) {
      if (segment === 'phase_1') {
        setIsVisible(true)
        setJauge(0)
        setIndex(0)
      }
      if (segment === 'phase_2') {
        setJauge(1 / 4)
        setIndex(1)
      }
      if (segment === 'phase_3') {
        setJauge(2 / 4)
        setIndex(2)
      }
      if (segment === 'phase_5_a') {
        setJauge(3 / 4)
        setIndex(3)
      }
      if (segment === 'phase_6') {
        setJauge(4 / 4)
        setIndex(4)
      }
      if (segment === 'audio_narnia') {
        setIsVisible(false)
      }
    } else {
      setIsVisible(false)
    }
  }, [isPedro1, segment, setJauge, setIndex])

  const items = []
  for (let i = 0; i < 5; i++) {
    items.push(
      <li
        key={i}
        className={`relative w-1/5 h-full flex items-center justify-center transition-opacity duration-500 ease-out-quad ${index > i ? 'opacity-30' : ''}`}
      >
        <UIIcon icon={icons[i % icons.length] as UIIconType} className='text-32' />
        <UIIcon
          icon='caretUp'
          className={`text-12 absolute bottom-4 left-1/2 -translate-x-1/2 transition-opacity duration-500 ease-out-quad ${index === i ? 'opacity-100' : 'opacity-0'}`}
        />
        <div
          className={`absolute w-6 h-6 rounded-full bg-mid-blue bottom-[7px] left-1/2 -translate-x-1/2 transition-opacity duration-500 ease-out-quad ${index !== i ? 'opacity-100' : 'opacity-0'}`}
        />
      </li>
    )
  }

  const elementRef = useRef<HTMLDivElement>(null)
  const { onEnter, onExit, timeout } = useRunnerUITransition(elementRef, { from: 'top' })

  return (
    <Transition
      in={isVisible}
      nodeRef={elementRef}
      onEnter={onEnter}
      onExit={onExit}
      mountOnEnter
      unmountOnExit
      timeout={timeout}
    >
      <div
        ref={elementRef}
        className='RunnerUIPedroTimeline Jauge w-full h-60 rounded-16 relative self-start mt-[44px] pointer-events-none max-w-248'
      >
        <div className='absolute bottom-0 right-0 pb-56 rounded-16 bg-secondary border-2 border-secondary'>
          <div className='px-24 py-12 text-body-s'>{t(`runner.pedro.2.timeline.label`)}</div>
        </div>

        <div className='h-full min-w-60 rounded-16 overflow-hidden relative bg-tertiary border-2 border-secondary'>
          <div className='Jauge__Background absolute inset-0'>
            <div
              className='Jauge__Background__Progress absolute top-0 left-[calc(20%+8px)] h-full w-[calc(80%-8px)] transition-transform duration-500 ease-out-back'
              style={{ transform: `translateX(${(1 - jauge) * -100}%)` }}
            >
              <div
                className={`absolute top-0 -left-56 right-0 bottom-0 rounded-12 transition-opacity duration-333 ease-out-quad bg-peach`}
              />
            </div>
          </div>
        </div>

        <ul className='absolute top-0 left-0 w-full h-full flex items-center justify-center px-8'>{items}</ul>
      </div>
    </Transition>
  )
}
